<script setup>
import ListItem from "@/components/molecules/list/list-item";
import List from "@/components/molecules/list";
import {
  productAdditionalDetailsProps,
  useProductAdditionalDetails
} from "@/components/organisms/product-sheet/additional-details/product-additional-details.mixin";

const props = defineProps({
  ...productAdditionalDetailsProps()
});

const {
  informationsValuesByGroup,
  groupValues,
  featuresToDisplay,
  getIconName
} = useProductAdditionalDetails(props);
</script>

<template>
  <List>
    <ListItem
      v-for="(groupInfos, index) in informationsValuesByGroup"
      :key="index+groupInfos.groupLabel"
    >
      <template v-if="groupInfos.groupLabel && groupInfos.groupLabel.length > 0">
        <h3
          v-if="groupInfos.groupLabel"
          class="u-mt-md"
        >
          {{ groupInfos.groupLabel }}
        </h3>
      </template>
      <template
        v-for="(info) in groupInfos.values"
        :key="info.label"
      >
        <p v-if="info.label">
          {{ info.label }}
        </p>
        <p v-if="info.value">
          {{ info.value }}
        </p>
      </template>
    </ListItem>
  </List>
</template>

<style lang="scss" scoped>
</style>
